/* pdpcore.js: the product page's data and logic, shared by every product page design.
   Everything here is computed from the real store data: PP (data.js), PPD (pdpdata.js:
   description, options, variants, images), PPE (pdpextra.js: real Judge.me reviews, photos of
   dogs using the product, image kinds) and PPX (home.js helpers, basket). Nothing is invented.

   A design file calls  PDPCORE.ready(function (M, UI) { ... })  and renders #pdp itself.
   M is the model of the current product (see the bottom of make() for every field);
   UI holds small shared widgets (gallery swipe, tabs, sticky bar, rails). */
(function () {
  'use strict';

  function make(X) {
    var PP = X.PP, C = X.C, esc = X.esc, money = X.money, prod = X.prod;
    var E = window.PPE || { reviews: {}, dogs: {}, kinds: {} };
    (function () {
      var LP = window.LIVE_PRODUCT, LR = window.LIVE_REVIEWS; if (!window.THEME_LIVE || !LP || !LP.handle) return;
      if (!LR || !LR.number_of_reviews) { delete E.reviews[LP.handle]; return; }
      var hist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }; (LR.histogram || []).forEach(function (x) { hist[x.rating] = x.frequency; });
      E.reviews[LP.handle] = { n: LR.number_of_reviews, avg: parseFloat(LR.average_rating) || 0, hist: hist, list: (LR.reviews || []).map(function (r) {
        return { r: r.rating, title: r.title || '', body: r.body || '', name: r.is_anonymous_reviewer ? 'Anonymous' : (r.reviewer_name || ''), date: String(r.created_at || '').slice(0, 10), verified: !!r.verified_buyer, pics: r.pictures_urls || [], variant: r.product_variant_title || '' };
      }) };
    })();

    /* ---------- which product ---------------------------------------------- */
    var h = (window.PPSITE && PPSITE.currentProduct()) || window.PDP_DEFAULT;
    if (!PP.products[h]) h = window.PDP_DEFAULT;
    var p = prod(h);
    var D = (window.PPD && window.PPD[h]) || { sec: [], opts: [], vars: [{ t: 'Default', o: ['Default'], p: p.p, c: p.c, a: true, sku: '' }], imgs: [], sub: false };
    document.title = X.plain(p.t) + ' | Poorly Pet';

    function uniq(a) { var s = {}; return a.filter(function (x) { if (!x || s[x]) return false; s[x] = 1; return true; }); }
    var ENT = { '&amp;': '&', '&nbsp;': ' ', '&#39;': "'", '&rsquo;': "'", '&lsquo;': "'", '&quot;': '"', '&ldquo;': '"', '&rdquo;': '"', '&lt;': '<', '&gt;': '>' };
    var strip = function (s) { return String(s || '').replace(/<[^>]+>/g, ' ').replace(/&[a-z#0-9]+;/gi, function (e) { return ENT[e.toLowerCase()] || ' '; }).replace(/\s+/g, ' ').trim(); };
    var okProd = function (x) { return x !== h && prod(x) && !/-bundle$/.test(x); };
    var tyOf = function (x) { return String(prod(x).ty || '').toLowerCase(); };
    var byRank = function (a, b) { return (prod(a).rk - prod(b).rk) || (prod(b).rc - prod(a).rc); };
    var U = C.usp;

    /* ---------- where it sits ---------------------------------------------- */
    var dept = null, shelf = null;
    var CO = window.PPSITE && window.PPSITE.categoryOf && window.PP_BY_HANDLE && window.PP_BY_HANDLE[h] ? window.PPSITE.categoryOf(window.PP_BY_HANDLE[h]) : null;
    if (CO) {
      dept = PP.taxonomy.filter(function (t) { return t.s === CO.dept.handle; })[0] || { l: CO.dept.title, ls: CO.dept.title, s: CO.dept.handle, subs: [] };
      shelf = CO.cat ? (dept.subs.filter(function (s) { return s.s === CO.cat.handle; })[0] || { l: CO.cat.title, s: CO.cat.handle, prods: window.PPSITE.collection(CO.cat.handle).products }) : null;
    }
    var areaOf = {};
    PP.groups.forEach(function (g) { g.items.forEach(function (it) { if (!areaOf[it.s]) areaOf[it.s] = g.area; }); });
    var crumbs = [{ l: 'Home', href: '/' }];
    if (dept) crumbs.push({ l: dept.l, href: '/collections/' + dept.s });
    if (shelf && !/^all /i.test(shelf.l)) crumbs.push({ l: shelf.l, href: '/collections/' + shelf.s });
    if (!dept) crumbs.push({ l: p.b, href: '/collections/' + X.slug(p.b) });
    crumbs.push({ l: p.t, href: null });

    /* ---------- conditions: the collections it is in; else the ones its own copy names --- */
    var real = uniq((X.prodConds[h] || []).filter(function (s) { return X.condBy[s]; }));
    function terms(l) {
      var s = l.toLowerCase(), out = [], m = /\(([^)]+)\)/.exec(s);
      if (m) { out.push(m[1]); s = s.replace(/\s*\([^)]*\)/, ''); }
      s = s.trim(); out.push(s, s.replace(/-/g, ' '));
      if (s.indexOf(' & ') > -1) s.split(' & ').forEach(function (x) { if (x.indexOf(' ') > -1) out.push(x); });
      return out.filter(function (x) { return x.length > 3; });
    }
    function fromCopy() {
      var text = D.sec.map(function (s) { return s[1]; }).join(' ').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ');
      text = text.split(/[.!?]\s+/).filter(function (s) { return !/\b(not|no|never|nor|without|cannot)\b/i.test(s); }).join(' . ').toLowerCase();
      var hits = [];
      Object.keys(X.condBy).forEach(function (s) {
        if (/^(recovery|hydrotherapy|physiotherapy)$/.test(s)) return;
        var at = -1;
        terms(X.condBy[s].l).forEach(function (t) {
          var m = new RegExp('\\b' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b').exec(text);
          if (m && (at < 0 || m.index < at)) at = m.index;
        });
        if (at > -1) hits.push([at, s]);
      });
      return hits.sort(function (a, b) { return a[0] - b[0]; }).map(function (x) { return x[1]; });
    }
    var conds = (real.length ? real : fromCopy()).slice(0, 4);
    var condCards = conds.map(function (s) { var it = X.condBy[s]; return { s: s, l: it.l, area: areaOf[s] || 'Condition', info: X.plain(it.info || ''), href: '/collections/' + s }; });
    var c0 = condCards[0] || null;
    var hwLine = ((C.helpsWith && C.helpsWith[h]) || [])[0] || '';
    if (hwLine.toLowerCase() === String(p.ty).toLowerCase()) hwLine = '';
    var chip = c0 ? 'For ' + X.lc(c0.l) : (hwLine || (shelf && !/^all /i.test(shelf.l) ? shelf.l : (dept ? dept.l : '')));

    /* ---------- the description, split into titled blocks and sorted ------------ */
    var optVals = {};
    D.opts.forEach(function (o) { o.v.forEach(function (v) { optVals[v.toLowerCase()] = 1; }); });
    function kindOf(lab) {
      var k = lab.toLowerCase().replace(/:\s*$/, '').trim();
      if (!k) return 'overview';
      if (optVals[k]) return 'size';
      if (/\?$/.test(k)) return 'faq';
      if (/helps? with|suitable for|ideal for|who is it for|good for|particularly/.test(k)) return 'supports';
      if (/size guide|sizing|measur|which size|size chart|fit guide/.test(k)) return 'size';
      if (/in the box|included|includes|what you get/.test(k)) return 'box';
      if (/ingredient|what is in it|what's in it|composition|analytical|nutrition|constituent|additive/.test(k)) return 'ingredients';
      if (/how to use|directions|feeding|how to feed|dosage|how to apply|application|getting the|setting the|choosing|how to fit|fitting/.test(k)) return 'use';
      if (/key features|features|benefits|what it does|how it works|why /.test(k)) return 'features';
      if (/how it'?s built|how it is built|materials|specification|specs|dimensions|construction/.test(k)) return 'build';
      if (/important|safety|caution|warning|note on|please involve|vet/.test(k)) return 'faq';
      if (/^\d|kg\b|cm\b/.test(k) && k.length < 32) return 'overview';
      return 'other';
    }
    var BLOCKS = [];
    D.sec.forEach(function (s) {
      var html = X.plain(s[1]);
      var re = /<h[1-4][^>]*>([\s\S]*?)<\/h[1-4]>|<p>\s*<(?:strong|b)>([^<]{2,70}?)<\/(?:strong|b)>\s*:?\s*<\/p>/g, lab = s[0], last = 0, m;
      function push(l, body) { l = strip(l).replace(/:\s*$/, ''); if (strip(body)) BLOCKS.push({ h: l, k: kindOf(l), html: body.trim() }); }
      while ((m = re.exec(html))) { push(lab, html.slice(last, m.index)); lab = m[1] || m[2]; last = re.lastIndex; }
      push(lab, html.slice(last));
    });
    BLOCKS.forEach(function (b, i) { if (i === 0 && b.k === 'other' && /\d/.test(b.h) && b.h.length < 32) b.k = 'overview'; });

    // "Tell me about" tabs: product information only, at most three, then delivery
    var TAB_ORDER = ['overview', 'features', 'use', 'ingredients', 'size', 'box', 'build', 'other'];
    var TAB_LABEL = { overview: 'Overview', features: 'Key features', use: 'How to use', ingredients: 'Ingredients', size: 'Size guide', box: 'In the box', build: "How it's built" };
    var tabs = [], spill = [];
    TAB_ORDER.forEach(function (k) {
      var bs = BLOCKS.filter(function (b) { return b.k === k; });
      if (!bs.length) return;
      if (k === 'other') { bs.forEach(function (b) { (tabs.length < 3 ? tabs : spill).push({ k: k, label: b.h, blocks: [b] }); }); return; }
      if (tabs.length >= 3) { spill = spill.concat(bs.map(function (b) { return { k: k, label: b.h || TAB_LABEL[k], blocks: [b] }; })); return; }
      var label = TAB_LABEL[k];
      if (k === 'features' && bs.length === 1 && bs[0].h && bs[0].h.length <= 16) label = bs[0].h;
      tabs.push({ k: k, label: label, blocks: bs });
    });
    tabs.forEach(function (t) {
      t.html = t.blocks.map(function (b) {
        var sub = b.h && !(t.blocks.length === 1 && (b.h === t.label || t.k === 'overview' || b.k === 'other' || b.k === 'features'));
        var sizeName = t.k === 'size' && optVals[b.h.toLowerCase()];
        return (sub ? '<h3' + (sizeName ? ' data-pdsz="' + esc(b.h.toLowerCase()) + '"' : '') + '>' + esc(b.h) + '</h3>' : '') + b.html;
      }).join('');
    });
    var copy = strip(D.sec.map(function (s) { return s[1]; }).join(' '));
    var madeToOrder = /made to order/i.test(copy), noReturns = /returns cannot be accepted|cannot be returned|non-returnable/i.test(copy);
    // Joe, 26 Sept 2026: no 30 day guarantee anywhere. Three promises only
    var promises = [
      { b: U[0][0], t: U[0][1] },
      madeToOrder ? { b: 'Made to order', t: 'the delivery note is in the product details' } : { b: U[2][0], t: U[2][1] },
      { b: U[1][0], t: U[1][1] }
    ];
    if (noReturns) promises.push({ b: 'Returns are not accepted', t: 'on this product' });
    tabs.push({ k: 'delivery', label: 'Delivery', html: '<ul>' + promises.map(function (x) { return '<li><b>' + esc(x.b) + ':</b> ' + esc(x.t) + '.</li>'; }).join('') + '</ul>' });
    var hasSizeTab = tabs.some(function (t) { return t.k === 'size'; });

    /* ---------- what it supports -------------------------------------------------- */
    var points = [];
    BLOCKS.filter(function (b) { return b.k === 'supports'; }).forEach(function (b) {
      var li = b.html.match(/<li>[\s\S]*?<\/li>/g);
      if (li) li.forEach(function (x) { points.push(strip(x)); });
      else b.html.split(/<\/p>|<br\s*\/?>/i).forEach(function (x) { if (strip(x)) points.push(strip(x).replace(/^[\u2022\-*]\s*/, '')); });
    });
    points = points.filter(function (x) { return x.length > 3; }).slice(0, 5);
    if (!points.length && C.helpsWith[h]) points = C.helpsWith[h].filter(function (x) { return x && x.toLowerCase() !== String(p.ty).toLowerCase(); }).slice(0, 4);

    /* ---------- options and variants -------------------------------------------- */
    var choice = [];
    D.opts.forEach(function (o, i) { if (o.v.length > 1) choice.push(i); });
    var sizeIdx = -1;
    choice.forEach(function (i) { if (/size|distance|length|measure|girth|width|height/i.test(D.opts[i].n) && !/pack/i.test(D.opts[i].n)) sizeIdx = i; });
    var opts = D.opts.map(function (o, i) { return { i: i, n: o.n, values: o.v, single: o.v.length < 2, hidden: o.v.length < 2 && (!o.v[0] || /^default/i.test(o.v[0])), size: i === sizeIdx }; });
    var firstVi = 0;
    D.vars.forEach(function (v, i) { if (v.a && (!D.vars[firstVi].a || v.p < D.vars[firstVi].p)) firstVi = i; });
    function findVar(sel) {
      for (var i = 0; i < D.vars.length; i++) { var v = D.vars[i]; if (choice.every(function (j) { return v.o[j] === sel[j]; })) return i; }
      return -1;
    }
    // is value val of option i buyable, given the other chosen options?
    function possible(i, val, sel) { return D.vars.some(function (v) { return v.a && v.o[i] === val && choice.every(function (j) { return j === i || v.o[j] === sel[j]; }); }); }
    // choose value val for option i from the current selection; returns the new variant index (or -1)
    function pick(sel, i, val) {
      var s2 = sel.slice(); s2[i] = val;
      var k = findVar(s2);
      if (k < 0 || !D.vars[k].a) { k = -1; D.vars.some(function (v, j) { if (v.a && v.o[i] === val) { k = j; return true; } return false; }); }
      return k;
    }
    function price(vi) { var v = D.vars[vi]; var was = v.c && v.c > v.p ? v.c : 0; return { now: v.p, was: was, save: was ? was - v.p : 0, available: v.a, name: /^default/i.test(v.t) ? '' : X.plain(v.t), sel: v.o.slice() }; }
    function pointsFor(vi, qty) { return Math.floor(D.vars[vi].p * qty) * 5; }
    function freeLeft(vi, qty) { return Math.max(0, X.FREE - D.vars[vi].p * qty); }
    var key = function (vi) { return D.vars.length > 1 ? h + '::' + vi : h; };
    function add(vi, qty, planOption) { if (!D.vars[vi].a) return false; X.add(key(vi), qty || 1, planOption); X.openDrawer('basket'); return true; }

    /* ---------- the kit ---------------------------------------------------------- */
    function companions() {
      var pool = X.goesWith([h]);
      conds.forEach(function (s) { pool = pool.concat(X.condBy[s].prods); });
      pool = uniq(pool).filter(okProd);
      var tn = String(p.ty || '').split(',')[0].trim().split(' ').pop().toLowerCase();
      var same = function (x) {
        return tyOf(x) === String(p.ty).toLowerCase() || (shelf && shelf.prods.indexOf(x) > -1 && !/^all /i.test(shelf.l)) ||
          (tn.length > 3 && String(prod(x).t).toLowerCase().indexOf(tn) > -1);
      };
      var diff = pool.filter(function (x) { return !same(x); }), picked = [], seen = {};
      diff.forEach(function (x) { if (picked.length < 3 && !seen[tyOf(x)]) { seen[tyOf(x)] = 1; picked.push(x); } });
      diff.forEach(function (x) { if (picked.length < 3 && picked.indexOf(x) < 0) picked.push(x); });
      if (picked.length < 3) {
        var more = [];
        if (dept) dept.subs.forEach(function (s) {
          if (s === shelf) return;
          var top = s.prods.filter(okProd).filter(function (x) { return !same(x); }).sort(byRank)[0];
          if (top) more.push(top);
        });
        more.concat(PP.best.filter(okProd)).forEach(function (x) { if (picked.length < 3 && picked.indexOf(x) < 0 && !same(x)) picked.push(x); });
      }
      return picked;
    }
    var kit = [];   // no care kit on the product page (kits removed site wide)
    // totals for this product (variant vi) plus the ticked companions; the ladder counts distinct products
    function kitTotals(vi, on) {
      var n = 1 + on.length;
      var PR = window.PPSITE.price([{ h: h, qty: 1, price: D.vars[vi].p }].concat(on.map(function (x) { return { h: x, qty: 1, price: prod(x).p }; })));
      var tot = PR.sub, pct = PR.off ? Math.round(PR.off / PR.sub * 100) : 0;
      return { n: n, pct: pct, total: tot, pay: PR.total, off: PR.off, label: PR.label,
        word: (['', 'Just this one', 'Two', 'Three', 'Four', 'Five'][n] || String(n)), next: X.ladderLine(n),
        button: n === 1 ? 'Add to basket' : 'Add ' + n + ' to basket' };
    }
    function addKit(vi, on) { if (!D.vars[vi].a) return false; X.add(key(vi), 1); on.forEach(function (x) { X.add(x, 1); }); X.openDrawer('basket'); return true; }

    /* ---------- questions ---------------------------------------------------------- */
    var QMAP = { 'a note on age': 'Is it suitable at any age?', 'important information': 'Anything I should know first?', 'important': 'Anything I should know first?',
      'please involve your vet': 'Should I talk to my vet first?', 'safety information': 'Anything I should know first?', 'safety': 'Anything I should know first?' };
    function asQ(lab) { var k = lab.toLowerCase().replace(/:\s*$/, '').trim(); return QMAP[k] || lab; }
    var faq = [];
    BLOCKS.filter(function (b) { return b.k === 'faq'; }).forEach(function (b) { faq.push({ q: asQ(b.h), a: b.html, own: true }); });
    spill.forEach(function (t) { t.blocks.forEach(function (b) { faq.push({ q: b.h || t.label, a: b.html, own: true }); }); });
    if (sizeIdx > -1) faq.push({ q: 'Which size do I need?', a: '<p>' + (hasSizeTab ? 'The size guide is in the product information above. ' : '') + esc(C.help[2][1]) + ': <a href="mailto:' + C.brand.email + '">' + esc(C.brand.email) + '</a>.</p>' });
    faq.push({ q: 'Has a vet looked at it?', a: '<p><b>' + esc(U[1][0]) + ':</b> ' + esc(U[1][1]) + '.</p>' });
    faq.push({ q: 'Is it the right thing for my dog?', a: '<p>' + esc(C.help[0][1]) + ': <a href="/pages/shop-by-symptom">shop by symptom</a>. Or email us, ' + esc(X.lc(C.brand.reply)) + '.</p>' });
    faq.push({ q: 'What if it is urgent?', a: '<p>' + esc(C.help[1][1]) + '.</p>' });
    var ask = 'mailto:' + C.brand.email + '?subject=' + encodeURIComponent('Question about ' + X.plain(p.t));

    /* ---------- images and dog photos --------------------------------------------- */
    var imgs = uniq(D.imgs && D.imgs.length ? D.imgs : [p.img].concat(p.gallery || []));
    var KIND = (E.kinds && E.kinds[h]) || [], src = D.imgs || [];
    // cut-out packshots sit contained on a pale ground; photographs and graphics fill their frame
    function isCut(u) { var i = src.indexOf(u), k = i > -1 ? KIND[i] : null; return k ? k === 'cutout' : /\.png(\?|$)/i.test(u); }
    // photos of real dogs using it: the live site's "Real dogs, real recoveries" set when there is one
    // (up to a dozen per product), else the photographs of dogs found in its own gallery
    var realDogs = (E.real && E.real[h]) || [];
    var dogs = realDogs.length ? realDogs.slice(0, 24) : (E.dogs[h] || []).slice(0, 6);

    /* ---------- this product's own Judge.me reviews ---------------------------------- */
    var R = E.reviews[h] || null, MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function when(d) { var m = /^(\d{4})-(\d\d)-(\d\d)/.exec(d || ''); return m ? Number(m[3]) + ' ' + MONTHS[Number(m[2]) - 1] + ' ' + m[1] : ''; }
    var reviews = R ? {
      avg: R.avg, n: R.n,
      hist: [5, 4, 3, 2, 1].map(function (s) { var n = Number(R.hist[String(s)] || 0); return { s: s, n: n, pct: R.n ? Math.round(n / R.n * 100) : 0 }; }),
      list: R.list.map(function (r) { return { r: r.r, title: r.title, body: r.body, name: r.name || 'Anonymous', date: when(r.date), verified: r.verified, variant: r.variant || '' }; }),
      filter: function (star) { return this.list.filter(function (r) { return !star || r.r === star; }); }
    } : null;
    var revPoints = (/(\d[\d,]*) points/.exec(((C.club.rows || []).filter(function (r) { return /review/i.test(r[0] + r[1]); })[0] || ['', ''])[1]) || [])[1] || '';

    /* ---------- recommended products ------------------------------------------------- */
    var rails = [];
    (function () {
      var used = [h], condList = [];
      conds.forEach(function (s) { condList = condList.concat(X.condBy[s].prods); });
      condList = uniq(condList).filter(okProd).sort(byRank);
      var noKit = condList.filter(function (x) { return kit.indexOf(x) < 0; });
      if (noKit.length >= 4) condList = noKit;
      if (c0 && condList.length >= 3) rails.push({ lead: 'Recommended for', em: X.lc(c0.l), all: { href: c0.href, l: 'Shop ' + X.lc(c0.l) }, items: condList.slice(0, 12) });
      else if (dept) {
        // the row holds what its heading says: this product's category when it has enough in it, else its department
        var own = shelf ? uniq(shelf.prods).filter(function (x) { return x !== h && okProd(x); }).sort(byRank) : [];
        var useShelf = own.length >= 3;
        var dl = useShelf ? own : uniq([].concat.apply([], dept.subs.map(function (s) { return s.prods; })).concat(window.PPSITE ? window.PPSITE.collection(dept.s).products : [])).filter(function (x) { return x !== h && okProd(x); }).sort(byRank);
        var lab = useShelf ? shelf.l : dept.l, to = useShelf ? shelf.s : dept.s;
        if (dl.length >= 3) rails.push({ lead: 'Recommended', em: X.lc(lab), all: { href: '/collections/' + to, l: 'Shop ' + X.lc(lab) }, items: dl.slice(0, 12) });
      }
      if (rails[0]) used = used.concat(rails[0].items);
      var bl = Object.keys(PP.products).filter(function (x) { return prod(x).b === p.b && okProd(x) && used.indexOf(x) < 0; }).sort(byRank);
      if (bl.length >= 3) rails.push({ lead: 'More from', em: p.b, all: { href: '/collections/' + X.slug(p.b), l: 'Shop ' + p.b }, items: bl.slice(0, 12) });
      if (rails.length < 2) {
        var pop = PP.best.filter(function (x) { return okProd(x) && used.indexOf(x) < 0 && bl.indexOf(x) < 0; });
        rails.push({ lead: 'Most popular with', em: 'pet parents', all: { href: '/collections/best-sellers', l: 'See all popular' }, items: pop.slice(0, 12) });
      }
    })();

    return {
      X: X, C: C, esc: esc, money: money, h: h, p: p, D: D,
      crumbs: crumbs, dept: dept, shelf: shelf, chip: chip, hwLine: hwLine,
      conds: conds, condCards: condCards, c0: c0,
      tabs: tabs, hasSizeTab: hasSizeTab, points: points, legal: C.legal, promises: promises, madeToOrder: madeToOrder, noReturns: noReturns,
      opts: opts, choice: choice, sizeIdx: sizeIdx, firstVi: firstVi, findVar: findVar, possible: possible, pick: pick, price: price,
      pointsFor: pointsFor, freeLeft: freeLeft, FREE: X.FREE, key: key, add: add, sub: !!D.sub, freqs: [2, 4, 6, 8],
      kit: kit, kitTotals: kitTotals, addKit: addKit, ladder: C.kit.ladder, kitLine: C.kit.line,
      faq: faq, ask: ask, email: C.brand.email, reply: C.brand.reply,
      imgs: imgs, isCut: isCut, dogs: dogs, dogsReal: realDogs.length > 0,
      reviews: reviews, revPoints: revPoints,
      rails: rails,
      meta: (window.PPM && window.PPM[h]) || null
    };
  }

  /* ---------- small shared widgets ------------------------------------------------ */
  var UI = {
    // a horizontal scroll-snap track of slides: returns go(i); calls onIndex(i) as it moves
    swipe: function (track, onIndex) {
      var cur = 0, raf = 0, reduced = window.PPX && window.PPX.reduced;
      function go(i) { var n = track.children.length; i = Math.max(0, Math.min(n - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); cur = i; onIndex(i); }
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== cur) { cur = i; onIndex(i); } });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      });
      return go;
    },
    // accessible tabs: buttons [role=tab] with aria-controls; arrow keys move
    tabs: function (list, onChange) {
      var btns = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      function show(i, focus) {
        btns.forEach(function (b, k) {
          var on = k === i; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
          var pn = document.getElementById(b.getAttribute('aria-controls')); if (pn) pn.hidden = !on;
          if (on && focus) b.focus();
        });
        if (onChange) onChange(i);
      }
      list.addEventListener('click', function (e) { var b = e.target.closest('[role="tab"]'); if (b) show(btns.indexOf(b)); });
      list.addEventListener('keydown', function (e) {
        var i = btns.indexOf(document.activeElement), n = btns.length; if (i < 0) return;
        if (e.key === 'ArrowRight') i = (i + 1) % n; else if (e.key === 'ArrowLeft') i = (i + n - 1) % n; else if (e.key === 'Home') i = 0; else if (e.key === 'End') i = n - 1; else return;
        e.preventDefault(); show(i, true);
      });
      return show;
    },
    // a bar that shows once `watch` has scrolled up out of view
    sticky: function (bar, watch) {
      var raf = 0;
      function set(show) { if (bar.classList.contains('on') === show) return; bar.classList.toggle('on', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true'); bar.querySelectorAll('button,a').forEach(function (b) { b.tabIndex = show ? 0 : -1; }); }
      var check = function () { set(watch.getBoundingClientRect().bottom < 0); };
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (en) { set(!en.isIntersecting && en.boundingClientRect.top < 0); }); }).observe(watch);
      window.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(check); }, { passive: true });
      set(false);
    },
    // a rail of the signed-off product card with the homepage scroller; call UI.initRail(id) after it is in the page
    railHTML: function (items, id) {
      var X = window.PPX;
      return '<div class="railwrap"><div class="rail prail" id="' + id + '" tabindex="0">' + items.map(X.pkCard).join('') + '</div>' +
        '<div class="scroller" id="' + id + 's"><button class="sarr prev" type="button" aria-label="Scroll back"><span>←</span></button>' +
        '<div class="track" id="' + id + 't"><i id="' + id + 'h"></i></div>' +
        '<button class="sarr next" type="button" aria-label="Scroll forward"><span>→</span></button></div></div>';
    },
    // a full-screen photo viewer: UI.lightbox(urls, i, alt). Arrows, swipe, Esc and the close button work
    lightbox: function (urls, start, alt) {
      var X = window.PPX, i = start || 0, box = document.createElement('div'), last = document.activeElement;
      box.className = 'pdlb'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Photo viewer');
      box.innerHTML = '<button class="pdlb-x" type="button" aria-label="Close">\u00d7</button>' +
        '<button class="pdlb-p" type="button" aria-label="Previous photo">\u2039</button><figure class="pdlb-f"><img alt=""></figure>' +
        '<button class="pdlb-n" type="button" aria-label="Next photo">\u203a</button>';
      var img = box.querySelector('img');
      function show(k) { i = (k + urls.length) % urls.length; img.src = X.sz(urls[i], 1400); img.alt = alt || ''; box.querySelector('.pdlb-p').hidden = box.querySelector('.pdlb-n').hidden = urls.length < 2; }
      function close() { document.removeEventListener('keydown', key); box.remove(); document.documentElement.style.overflow = ''; if (last && last.focus) last.focus(); }
      function key(e) { if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') show(i + 1); else if (e.key === 'ArrowLeft') show(i - 1); }
      box.addEventListener('click', function (e) {
        if (e.target.closest('.pdlb-x') || e.target === box) close();
        else if (e.target.closest('.pdlb-p')) show(i - 1); else if (e.target.closest('.pdlb-n')) show(i + 1);
      });
      var sx = null;
      box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1)); sx = null; });
      document.addEventListener('keydown', key);
      document.body.appendChild(box); document.documentElement.style.overflow = 'hidden';
      show(i); box.querySelector('.pdlb-x').focus();
    },
    initRail: function (id) { var X = window.PPX, $ = X.$; X.scroller($('#' + id), $('#' + id + 's'), $('#' + id + 't'), $('#' + id + 'h')); }
  };

  var queue = [], M = null;
  // after a design has drawn the page: honour #y<px> (review harness) and #reviews links
  function run(fn) {
    fn(M, UI);
    var ym = /^#y(\d+)$/.exec(location.hash);
    if (ym) window.scrollTo(0, Number(ym[1]));
    else if (location.hash === '#reviews') { var rv = document.getElementById('reviews'); if (rv) rv.scrollIntoView(); }
  }
  window.PDPCORE = {
    ready: function (fn) { if (M) run(fn); else queue.push(fn); },
    UI: UI
  };
  function boot() {
    if (M || !window.PPX) return;
    M = make(window.PPX);
    queue.splice(0).forEach(run);
  }
  if (window.PPX) setTimeout(boot, 0); else document.addEventListener('ppx:ready', boot);
})();
